import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import styles from "../../../layout/Auth/Auth.module.scss";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/Common/Loader";
import { Spinner } from "reactstrap";
import { useFirebase } from "../../../firebase/firebase";
import { toast } from "react-toastify";
import { Country, State, City } from "country-state-city";
import GoogleAutocomplete from "../../../components/Common/GoogleAutoComplete";
import fileUploader from "../../../utilities/fileUploader";
import { catchAsync } from "../../../utilities/utilities";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import Loading from "../../../components/Common/Loading";
import { REGISTER } from "../../../services/ApiCalls";

const schema = z
  .object({
    name: z.string().min(1, { message: "Name is required" }),
    email: z
      .string()
      .min(1, { message: "Email is required" })
      .email("Invalid email address"),
    password: z.string().min(1, { message: "Password is required" }),
    mobileNumber: z.string().min(1, { message: "Mobile number is required" }),
    confirmPassword: z
      .string()
      .min(1, { message: "Confirm password is required" }),
    profileImage: z.string().min(1, { message: "Profile image is required" }),
    country: z.string().min(1, { message: "Country is required" }),
    state: z.string().min(1, { message: "State is required" }),
    city: z.string().min(1, { message: "City is required" }),
    address: z.string().min(1, { message: "Address is required" }),
    description: z.string().optional(),
    // status: z.boolean().optional(),
    countryCode: z.string().optional(),
    // lat: z.string().optional(),
    // lng: z.string().optional(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

const Register = () => {
  const [loader, setLoader] = useState(false);
  const loading = useSelector((s) => s.login.loading);
  const [imgloader, setImgLoader] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [confirmPass, setConfirmPass] = useState();

  const navigate = useNavigate();
  const [pass, setPass] = useState();
  const handlePass = () => {
    setPass(!pass);
  };
  const handleConfirmPass = () => {
    setConfirmPass(!confirmPass);
  };
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      name: "",
      country: "",
      state: "",
      profileImage: "",
      city: "",
      address: "",
      mobileNumber: "",
      password: "",
      description: "",
      email: "",
      status: false,
      countryCode: "",
      lat: "",
      lng: "",
    },
  });
  const token = useFirebase();

  const firebasedata = token?.token;
  const submitHandler = async (data) => {
    console.log(data, "data=====<>");

    if (imgloader) {
      toast.error("Please wait, image is still uploading...");
      return;
    }

    setLoader(true);

    const { confirmPassword, ...payload } = data;

    const finalPayload = {
      ...payload,
      location: {
        type: "Point",
        coordinates: [Number(watch("lng")), Number(watch("lat"))],
      },
    };

    try {
      const response = await REGISTER(finalPayload);
      console.log(response, "response==== register data");

      if (response?.data?.status === "success") {
        toast.success(response?.data?.message || "Registered Successfully!");
        navigate("/login");
        reset({
          name: "",
          country: "",
          state: "",
          city: "",
          description: "",
          mobileNumber: "",
          email: "",
          password: "",
          address: "",
          lat: "",
          lng: "",
        });
      } else {
        toast.error(response?.data?.message || "Invalid Credentials!");
      }
    } catch (error) {
      console.error("Register Error:", error);
      toast.error(error?.response?.data?.message || "Something went wrong!");
    } finally {
      setLoader(false);
    }
  };

  const addressChangeHandler = (address) => {
    setValue("address", address?.address, { shouldValidate: true });
    setValue("lat", address?.lat, { shouldValidate: true });
    setValue("lng", address?.lng, { shouldValidate: true });
  };

  const countryOptions = Country.getAllCountries().map((c) => ({
    value: c.isoCode,
    label: c.name,
  }));

  const stateOptions = (countryCode) =>
    State.getStatesOfCountry(countryCode).map((s) => ({
      value: s.isoCode,
      label: s.name,
    }));

  const cityOptions = (countryCode, stateCode) =>
    City.getCitiesOfState(countryCode, stateCode).map((ci) => ({
      value: ci.name,
      label: ci.name,
    }));

  const handleImageChange = catchAsync(async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImgLoader(true);
    const res = await fileUploader(file);

    setValue("profileImage", res?.url || "", { shouldValidate: true });
    setImgLoader(false);

    const reader = new FileReader();
    reader.onloadend = () => setImagePreview(reader.result);
    reader.readAsDataURL(file);
  });
  console.log(errors, "error-----<>");
  return (
    <>
      <div className="top py-2 d-flex justify-content-center align-items-center">
        <h5 className="m-0 fw-sbold text-black">Hotel Admin Signup</h5>
      </div>
      <div className="formInnerScrroll formInner position-relative px-lg-3">
        {loading && (
          <div
            className="spinner position-absolute"
            style={{
              zIndex: 9999,
              left: 0,
              right: 0,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <Spinner
              style={{
                color: "#000",
              }}
            />
          </div>
        )}
        <div className="w-100 inner">
          <Form
            className={`${styles.form} pt-lg-4 pt-2 spinner-content position-relative`}
            onSubmit={handleSubmit(submitHandler)}
          >
            <Row className="justify-content-center">
              <Col lg="12" className="my-2">
                <label>Name</label>
                <input
                  type="text"
                  className={`${styles.formControl} form-control`}
                  {...register("name")}
                  placeholder="Enter name..."
                />
                {errors?.name && (
                  <p className="text-danger">{errors.name.message}</p>
                )}
              </Col>
              <Col lg="12" className="my-2">
                <label>Email</label>
                <input
                  type="email"
                  className={`${styles.formControl} form-control`}
                  {...register("email")}
                />
                {errors?.email && (
                  <p className="text-danger">{errors.email.message}</p>
                )}
              </Col>

              <Col lg="12" className="my-2">
                <label>Mobile Number</label>
                <Controller
                  control={control}
                  name="mobileNumber"
                  className={`${styles.formControl} form-control`}
                  render={({ field }) => (
                    <PhoneInput
                      {...field}
                      country={"us"}
                      value={field.value}
                      onChange={(value, { dialCode }) => {
                        setValue("countryCode", dialCode);
                        field.onChange(value);
                      }}
                    />
                  )}
                />
                {errors?.mobileNumber && (
                  <p className="text-danger">{errors.mobileNumber.message}</p>
                )}
              </Col>

              <Col lg="12" className="my-2">
                <label>Country</label>
                <Controller
                  control={control}
                  className={`${styles.formControl} form-control`}
                  name="country"
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={countryOptions}
                      value={countryOptions.find(
                        (c) =>
                          c.label === field.value || c.value === field.value
                      )}
                      onChange={(option) => {
                        setValue("country", option.label, {
                          shouldValidate: true,
                        });
                        setValue("state", "");
                        setValue("city", "");
                      }}
                    />
                  )}
                />
                {errors?.country && (
                  <p className="text-danger">{errors.country.message}</p>
                )}
              </Col>

              <Col lg="12" className="my-2">
                <label>State</label>
                <Controller
                  control={control}
                  name="state"
                  className={`${styles.formControl} form-control`}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={stateOptions(
                        Country.getAllCountries().find(
                          (c) => c.name === watch("country")
                        )?.isoCode
                      )}
                      value={stateOptions(
                        Country.getAllCountries().find(
                          (c) => c.name === watch("country")
                        )?.isoCode
                      ).find((s) => s.label === field.value)}
                      onChange={(option) => {
                        setValue("state", option.label, {
                          shouldValidate: true,
                        });
                        setValue("city", "");
                      }}
                    />
                  )}
                />
                {errors?.state && (
                  <p className="text-danger">{errors.state.message}</p>
                )}
              </Col>

              <Col lg="12" className="my-2">
                <label>City</label>
                <Controller
                  control={control}
                  name="city"
                  className={`${styles.formControl} form-control`}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={cityOptions(
                        Country.getAllCountries().find(
                          (c) => c.name === watch("country")
                        )?.isoCode,
                        State.getStatesOfCountry(
                          Country.getAllCountries().find(
                            (c) => c.name === watch("country")
                          )?.isoCode
                        ).find((s) => s.name === watch("state"))?.isoCode
                      )}
                      value={cityOptions(
                        Country.getAllCountries().find(
                          (c) => c.name === watch("country")
                        )?.isoCode,
                        State.getStatesOfCountry(
                          Country.getAllCountries().find(
                            (c) => c.name === watch("country")
                          )?.isoCode
                        ).find((s) => s.name === watch("state"))?.isoCode
                      ).find((ci) => ci.label === field.value)}
                      onChange={(option) =>
                        setValue("city", option.label, {
                          shouldValidate: true,
                        })
                      }
                    />
                  )}
                />
                {errors?.city && (
                  <p className="text-danger">{errors.city.message}</p>
                )}
              </Col>
              <Col lg="12" className="my-2">
                <label>Address</label>
                <GoogleAutocomplete
                  lat={watch("lat")}
                  lng={watch("lng")}
                  name={"address"}
                  className={`${styles.formControl} form-control`}
                  address={watch("address")}
                  onChange={addressChangeHandler}
                />
                {errors?.address && (
                  <p className="text-danger">{errors?.address?.message}</p>
                )}
              </Col>

              <Col lg="12" className="my-2">
                <label
                  htmlFor=""
                  className="form-label m-0 pb-1 text-black fw-sbold"
                >
                  Password
                </label>
                <div className="position-relative iconWithText">
                  <input
                    type={pass ? "text" : "password"}
                    className={`${styles.formControl} form-control`}
                    placeholder="*************"
                    {...register("password")}
                  />
                  <Button
                    onClick={handlePass}
                    className="border-0 p-0 position-absolute icn"
                    variant="transparent"
                    style={{ right: 10 }}
                  >
                    {pass ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 14 11"
                        fill="none"
                      >
                        <path
                          d="M8.96236 5.23432C8.96236 5.60618 8.8521 5.96968 8.64551 6.27886C8.43892 6.58804 8.14529 6.82902 7.80174 6.97132C7.4582 7.11362 7.08017 7.15085 6.71546 7.07831C6.35076 7.00576 6.01576 6.8267 5.75282 6.56376C5.48988 6.30082 5.31082 5.96582 5.23827 5.60112C5.16573 5.23641 5.20296 4.85838 5.34526 4.51484C5.48756 4.17129 5.72854 3.87766 6.03772 3.67107C6.34691 3.46448 6.71041 3.35422 7.08226 3.35422C7.58089 3.35422 8.0591 3.5523 8.41169 3.90489C8.76428 4.25748 8.96236 4.73569 8.96236 5.23432ZM13.8945 5.54768C13.7817 5.73569 11.1621 10.2479 7.08226 10.2479C3.00242 10.2479 0.382804 5.73569 0.269997 5.54768C0.214993 5.45241 0.186035 5.34433 0.186035 5.23432C0.186035 5.12432 0.214993 5.01624 0.269997 4.92097C0.382804 4.73296 3.00242 0.220703 7.08226 0.220703C11.1621 0.220703 13.7817 4.73296 13.8945 4.92097C13.9495 5.01624 13.9785 5.12432 13.9785 5.23432C13.9785 5.34433 13.9495 5.45241 13.8945 5.54768ZM10.2158 5.23432C10.2158 4.61457 10.032 4.00874 9.68768 3.49344C9.34336 2.97813 8.85397 2.5765 8.2814 2.33934C7.70882 2.10217 7.07878 2.04011 6.47094 2.16102C5.8631 2.28193 5.30476 2.58037 4.86653 3.0186C4.4283 3.45683 4.12986 4.01516 4.00895 4.62301C3.88804 5.23085 3.9501 5.86089 4.18727 6.43347C4.42443 7.00604 4.82607 7.49543 5.34137 7.83975C5.85667 8.18406 6.46251 8.36784 7.08226 8.36784C7.91331 8.36784 8.71034 8.0377 9.29798 7.45005C9.88563 6.86241 10.2158 6.06538 10.2158 5.23432Z"
                          fill="#B1B1B1"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 14 11"
                        fill="none"
                      >
                        <path
                          d="M8.96236 5.23432C8.96236 5.60618 8.8521 5.96968 8.64551 6.27886C8.43892 6.58804 8.14529 6.82902 7.80174 6.97132C7.4582 7.11362 7.08017 7.15085 6.71546 7.07831C6.35076 7.00576 6.01576 6.8267 5.75282 6.56376C5.48988 6.30082 5.31082 5.96582 5.23827 5.60112C5.16573 5.23641 5.20296 4.85838 5.34526 4.51484C5.48756 4.17129 5.72854 3.87766 6.03772 3.67107C6.34691 3.46448 6.71041 3.35422 7.08226 3.35422C7.58089 3.35422 8.0591 3.5523 8.41169 3.90489C8.76428 4.25748 8.96236 4.73569 8.96236 5.23432ZM13.8945 5.54768C13.7817 5.73569 11.1621 10.2479 7.08226 10.2479C3.00242 10.2479 0.382804 5.73569 0.269997 5.54768C0.214993 5.45241 0.186035 5.34433 0.186035 5.23432C0.186035 5.12432 0.214993 5.01624 0.269997 4.92097C0.382804 4.73296 3.00242 0.220703 7.08226 0.220703C11.1621 0.220703 13.7817 4.73296 13.8945 4.92097C13.9495 5.01624 13.9785 5.12432 13.9785 5.23432C13.9785 5.34433 13.9495 5.45241 13.8945 5.54768ZM10.2158 5.23432C10.2158 4.61457 10.032 4.00874 9.68768 3.49344C9.34336 2.97813 8.85397 2.5765 8.2814 2.33934C7.70882 2.10217 7.07878 2.04011 6.47094 2.16102C5.8631 2.28193 5.30476 2.58037 4.86653 3.0186C4.4283 3.45683 4.12986 4.01516 4.00895 4.62301C3.88804 5.23085 3.9501 5.86089 4.18727 6.43347C4.42443 7.00604 4.82607 7.49543 5.34137 7.83975C5.85667 8.18406 6.46251 8.36784 7.08226 8.36784C7.91331 8.36784 8.71034 8.0377 9.29798 7.45005C9.88563 6.86241 10.2158 6.06538 10.2158 5.23432Z"
                          fill="#B1B1B1"
                        />
                        <line
                          x1="1"
                          y1="1"
                          x2="13"
                          y2="10"
                          stroke="#B1B1B1"
                          strokeWidth="1.5"
                        />
                      </svg>
                    )}
                  </Button>
                </div>
                {errors?.password && (
                  <p className="text-danger m-0">{errors.password.message}</p>
                )}
              </Col>
              <Col lg="12" className="my-2">
                <label>Confirm Password</label>
                <div className="position-relative iconWithText">
                  <input
                    type={pass ? "text" : "password"}
                    className={`${styles.formControl} form-control`}
                    placeholder="*************"
                    {...register("confirmPassword")}
                  />
                  <Button
                    onClick={handleConfirmPass}
                    className="border-0 p-0 position-absolute icn"
                    variant="transparent"
                    style={{ right: 10 }}
                  >
                    {confirmPass ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 14 11"
                        fill="none"
                      >
                        <path
                          d="M8.96236 5.23432C8.96236 5.60618 8.8521 5.96968 8.64551 6.27886C8.43892 6.58804 8.14529 6.82902 7.80174 6.97132C7.4582 7.11362 7.08017 7.15085 6.71546 7.07831C6.35076 7.00576 6.01576 6.8267 5.75282 6.56376C5.48988 6.30082 5.31082 5.96582 5.23827 5.60112C5.16573 5.23641 5.20296 4.85838 5.34526 4.51484C5.48756 4.17129 5.72854 3.87766 6.03772 3.67107C6.34691 3.46448 6.71041 3.35422 7.08226 3.35422C7.58089 3.35422 8.0591 3.5523 8.41169 3.90489C8.76428 4.25748 8.96236 4.73569 8.96236 5.23432ZM13.8945 5.54768C13.7817 5.73569 11.1621 10.2479 7.08226 10.2479C3.00242 10.2479 0.382804 5.73569 0.269997 5.54768C0.214993 5.45241 0.186035 5.34433 0.186035 5.23432C0.186035 5.12432 0.214993 5.01624 0.269997 4.92097C0.382804 4.73296 3.00242 0.220703 7.08226 0.220703C11.1621 0.220703 13.7817 4.73296 13.8945 4.92097C13.9495 5.01624 13.9785 5.12432 13.9785 5.23432C13.9785 5.34433 13.9495 5.45241 13.8945 5.54768ZM10.2158 5.23432C10.2158 4.61457 10.032 4.00874 9.68768 3.49344C9.34336 2.97813 8.85397 2.5765 8.2814 2.33934C7.70882 2.10217 7.07878 2.04011 6.47094 2.16102C5.8631 2.28193 5.30476 2.58037 4.86653 3.0186C4.4283 3.45683 4.12986 4.01516 4.00895 4.62301C3.88804 5.23085 3.9501 5.86089 4.18727 6.43347C4.42443 7.00604 4.82607 7.49543 5.34137 7.83975C5.85667 8.18406 6.46251 8.36784 7.08226 8.36784C7.91331 8.36784 8.71034 8.0377 9.29798 7.45005C9.88563 6.86241 10.2158 6.06538 10.2158 5.23432Z"
                          fill="#B1B1B1"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 14 11"
                        fill="none"
                      >
                        <path
                          d="M8.96236 5.23432C8.96236 5.60618 8.8521 5.96968 8.64551 6.27886C8.43892 6.58804 8.14529 6.82902 7.80174 6.97132C7.4582 7.11362 7.08017 7.15085 6.71546 7.07831C6.35076 7.00576 6.01576 6.8267 5.75282 6.56376C5.48988 6.30082 5.31082 5.96582 5.23827 5.60112C5.16573 5.23641 5.20296 4.85838 5.34526 4.51484C5.48756 4.17129 5.72854 3.87766 6.03772 3.67107C6.34691 3.46448 6.71041 3.35422 7.08226 3.35422C7.58089 3.35422 8.0591 3.5523 8.41169 3.90489C8.76428 4.25748 8.96236 4.73569 8.96236 5.23432ZM13.8945 5.54768C13.7817 5.73569 11.1621 10.2479 7.08226 10.2479C3.00242 10.2479 0.382804 5.73569 0.269997 5.54768C0.214993 5.45241 0.186035 5.34433 0.186035 5.23432C0.186035 5.12432 0.214993 5.01624 0.269997 4.92097C0.382804 4.73296 3.00242 0.220703 7.08226 0.220703C11.1621 0.220703 13.7817 4.73296 13.8945 4.92097C13.9495 5.01624 13.9785 5.12432 13.9785 5.23432C13.9785 5.34433 13.9495 5.45241 13.8945 5.54768ZM10.2158 5.23432C10.2158 4.61457 10.032 4.00874 9.68768 3.49344C9.34336 2.97813 8.85397 2.5765 8.2814 2.33934C7.70882 2.10217 7.07878 2.04011 6.47094 2.16102C5.8631 2.28193 5.30476 2.58037 4.86653 3.0186C4.4283 3.45683 4.12986 4.01516 4.00895 4.62301C3.88804 5.23085 3.9501 5.86089 4.18727 6.43347C4.42443 7.00604 4.82607 7.49543 5.34137 7.83975C5.85667 8.18406 6.46251 8.36784 7.08226 8.36784C7.91331 8.36784 8.71034 8.0377 9.29798 7.45005C9.88563 6.86241 10.2158 6.06538 10.2158 5.23432Z"
                          fill="#B1B1B1"
                        />
                        <line
                          x1="1"
                          y1="1"
                          x2="13"
                          y2="10"
                          stroke="#B1B1B1"
                          strokeWidth="1.5"
                        />
                      </svg>
                    )}
                  </Button>
                </div>
                {errors?.confirmPassword && (
                  <p className="text-danger">
                    {errors.confirmPassword.message}
                  </p>
                )}
              </Col>

              <Col lg="12" className="my-2">
                <label>Description</label>
                <textarea
                  className="form-control"
                  {...register("description")}
                  rows={3}
                ></textarea>
              </Col>

              <Col lg={12} className="text-center">
                <label className="d-flex justify-content-start align-items-start">
                  Profile Image
                </label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control my-2"
                  onChange={handleImageChange}
                />
                {errors?.profileImage && (
                  <p className="text-danger text-start m-0">
                    {errors.profileImage.message}
                  </p>
                )}
                {imgloader ? (
                  <Loading fullSize={false} />
                ) : (
                  (imagePreview || watch("profileImage")) && (
                    <img
                      src={imagePreview || watch("profileImage")}
                      alt="Preview"
                      className="rounded-circle shadow"
                      style={{ width: 100, height: 100, objectFit: "cover" }}
                    />
                  )
                )}
              </Col>

              <Col lg="12" className="my-2 text-center">
                <p className="m-0 fw-sbold text-black">
                  Already have an account?{" "}
                  <Link to="/login" style={{ color: "#E8307A" }}>
                    Log In
                  </Link>
                </p>
              </Col>
              <Col lg="8" className="my-2">
                <div className={`${styles.btnWrpper} pt-3 btnWrpper`}>
                  <button
                    style={{ backgroundColor: "#E8307A", color: "#fff" }}
                    type="submit"
                    className="d-flex align-items-center py-2 justify-content-center w-100 rounded-2 border-0"
                  >
                    {loader ? <Loader /> : "Register"}
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};
export default Register;
